import React from 'react'
import PropTypes from 'prop-types'
import TwitterImg from '../../../assets/twitter.svg'
import FacebookImg from '../../../assets/facebook.svg'
import { getTwitterRestaurantReference } from '../../../utils/social-utils'

import './SocialBanner.css'

export const SocialBanner = ({
  socialMediaLinks: { twitterLink, facebookLink },
  whiteLabelName
}) => {
  const ooLink = window.location.href.slice(0, window.location.href.indexOf('/confirm'))
  const message = `Every order makes a difference. Order from ${getTwitterRestaurantReference(twitterLink, whiteLabelName)} to show your support today.`
  const twitterShareLink = `https://twitter.com/intent/tweet?url=${encodeURIComponent(ooLink)}&text=${encodeURIComponent(message)}`
  const facebookShareLink = `https://www.facebook.com/sharer/sharer.php?u=${ooLink}`

  return (
    <div styleName='banner'>
      <h2 styleName='header'>Share Your Support</h2>
      <p styleName='p'>Every order makes a difference. Share and encourage others to support our restaurant.</p>
      <br />
      <p styleName='p'>Follow us to keep up with the latest from our team.</p>
      <br />
      <div>
        <a href={facebookShareLink} rel='noopener noreferrer' target='_blank' data-testid='social-share-facebook' className='facebookButton'>
          <FacebookImg
            roll='img'
            title='Share on facebook'
            styleName='socialMediaImg' />
        </a>
        <a href={twitterShareLink} rel='noopener noreferrer' target='_blank' data-testid='social-share-twitter' className='twitterButton'>
          <TwitterImg
            roll='img'
            title='Share on twitter'
            styleName='socialMediaImg' />
        </a>
      </div>
    </div>
  )
}

const SocialMediaLinksShape = PropTypes.shape({
  twitterLink: PropTypes.string,
  facebookLink: PropTypes.string
})

SocialBanner.propTypes = {
  socialMediaLinks: SocialMediaLinksShape,
  whiteLabelName: PropTypes.string
}
